import { render, staticRenderFns } from "./NewBookList.vue?vue&type=template&id=a3196146&scoped=true&"
import script from "./NewBookList.vue?vue&type=script&lang=js&"
export * from "./NewBookList.vue?vue&type=script&lang=js&"
import style0 from "./NewBookList.vue?vue&type=style&index=0&id=a3196146&scoped=true&lang=scss&"
import style1 from "./NewBookList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./NewBookList.vue?vue&type=style&index=2&id=a3196146&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3196146",
  null
  
)

export default component.exports